<!-- @format -->

<section class="homr-wire-spot-content hmf-position-relative hmf-mb-m hmf-mb-m-xl">
	<ng-container *ngIf="enhancedProductCardContent$ | async as slides">
		<ng-container>
			<hmf-carousel
				[showHeader]="false"
				[showTitle]="false"
				[showSubtitle]="false"
				[showActionButton]="false">
				<article
					*ngFor="let slide of slides; trackBy: trackBySlide"
					class="homr-wire-spot-card hmf-display-flex hmf-mr-xxs hmf-mr-m-s">
					<div
						class="homr-wire-spot-left-column hmf-flex-column hmf-justify-content-center hmf-px-s hmf-px-m-xl hmf-mr-xxs hmf-mr-m-s">
						<img
							*ngIf="slide.logo && slide.logo === 'calia'"
							class="homr-wire-spot-logo hmf-display-flex hmf-mb-s"
							src="assets/image/calia-logo.svg"
							alt="Calia logo"
							[attr.loading]="lazyLoadImages() ? 'lazy' : 'eager'" />
						<p
							*ngIf="slide.title"
							class="homr-wire-spot-title hmf-mb-xxs hmf-header-bold-l">
							{{ slide.title }}
						</p>
						<div
							[innerHTML]="decodeURIPipe.transform(slide.wysiwyg)"
							class="homr-wire-spot-text"></div>
					</div>
					<div
						*ngIf="slide.visualAssets && slide.visualAssets.length"
						class="homr-wire-spot-image">
						<img
							#img
							[alt]="slide.visualAssets[0]['0'].altText"
							[attr.loading]="lazyLoadImages() ? 'lazy' : 'eager'"
							[src]="slide.visualAssets[0]['0'].value"
							(error)="utilityService.setFallbackImage($event, fallbackImage)" />
					</div>
				</article>
			</hmf-carousel>
		</ng-container>
	</ng-container>
</section>
